import * as i0 from '@angular/core';
import { EventEmitter, booleanAttribute, HostBinding, Input, Output, Component, NgModule, Directive } from '@angular/core';
import { CrntButton as CrntButton$1, CrntCheckboxGroup as CrntCheckboxGroup$1, CrntCheckbox as CrntCheckbox$1, CrntComponentLoader as CrntComponentLoader$1, CrntFormGroupHelpText as CrntFormGroupHelpText$1, CrntFormGroupLabelIndicator as CrntFormGroupLabelIndicator$1, CrntFormGroupLabel as CrntFormGroupLabel$1, CrntFormGroupValidationMessage as CrntFormGroupValidationMessage$1, CrntFormGroup as CrntFormGroup$1, CrntIconButton as CrntIconButton$1, CrntIcon as CrntIcon$1, CrntRadioGroup as CrntRadioGroup$1, CrntRadio as CrntRadio$1, CrntTextInput as CrntTextInput$1, CrntVisuallyHidden as CrntVisuallyHidden$1 } from '@essent/current-web';
import * as i1 from '@angular/router';
import { UrlTree } from '@angular/router';

CrntButton$1.define();
class CrntButton {
    _elementRef;
    blur = new EventEmitter();
    click = new EventEmitter();
    crntBlur = new EventEmitter();
    crntFocus = new EventEmitter();
    focus = new EventEmitter();
    href;
    state = 'enabled';
    target;
    type;
    variant = 'primary';
    /**
     * @region fullWidth
     */
    fullWidth = false;
    get _fullWidth() {
        return this.fullWidth ? 'full-width' : null;
    }
    /**
     * @region inverted
     */
    inverted = false;
    get _inverted() {
        return this.inverted ? 'inverted' : null;
    }
    /**
     * @region Properly handle disabled states
     * Angular does not respect stopImmediatePropagation from coming from other elements
     * https://github.com/angular/angular/issues/9587
     * https://github.com/angular/angular/issues/47463
     * This explicit workaround using elementRef is respected by the Angular event engine.
     */
    get _isDisabled() {
        return ['disabled', 'processing', 'success'].includes(this.state);
    }
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this._elementRef.nativeElement.addEventListener('click', this._handleClick.bind(this));
    }
    ngOnDestroy() {
        this._elementRef.nativeElement.removeEventListener('click', this._handleClick.bind(this));
    }
    _handleClick(event) {
        if (this._isDisabled) {
            event.stopImmediatePropagation();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntButton, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: CrntButton, isStandalone: true, selector: "crnt-button", inputs: { href: "href", state: "state", target: "target", type: "type", variant: "variant", fullWidth: ["fullWidth", "fullWidth", booleanAttribute], inverted: ["inverted", "inverted", booleanAttribute] }, outputs: { blur: "blur", click: "click", crntBlur: "crnt-blur", crntFocus: "crnt-focus", focus: "focus" }, host: { properties: { "attr.href": "this.href", "attr.state": "this.state", "attr.target": "this.target", "attr.type": "this.type", "attr.variant": "this.variant", "attr.full-width": "this._fullWidth", "attr.inverted": "this._inverted" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntButton, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-button',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { blur: [{
                type: Output,
                args: ['blur']
            }], click: [{
                type: Output,
                args: ['click']
            }], crntBlur: [{
                type: Output,
                args: ['crnt-blur']
            }], crntFocus: [{
                type: Output,
                args: ['crnt-focus']
            }], focus: [{
                type: Output,
                args: ['focus']
            }], href: [{
                type: HostBinding,
                args: ['attr.href']
            }, {
                type: Input
            }], state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }], target: [{
                type: HostBinding,
                args: ['attr.target']
            }, {
                type: Input
            }], type: [{
                type: HostBinding,
                args: ['attr.type']
            }, {
                type: Input
            }], variant: [{
                type: HostBinding,
                args: ['attr.variant']
            }, {
                type: Input
            }], fullWidth: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _fullWidth: [{
                type: HostBinding,
                args: ['attr.full-width']
            }], inverted: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _inverted: [{
                type: HostBinding,
                args: ['attr.inverted']
            }] } });

CrntCheckboxGroup$1.define();
class CrntCheckboxGroup {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntCheckboxGroup, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: CrntCheckboxGroup, isStandalone: true, selector: "crnt-checkbox-group", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute] }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntCheckboxGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-checkbox-group',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }] } });

CrntCheckbox$1.define();
class CrntCheckbox {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    /**
     * @region bordered
     */
    bordered = false;
    get _bordered() {
        return this.bordered ? 'bordered' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntCheckbox, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: CrntCheckbox, isStandalone: true, selector: "crnt-checkbox", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute], bordered: ["bordered", "bordered", booleanAttribute] }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink", "attr.bordered": "this._bordered" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntCheckbox, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-checkbox',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }], bordered: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _bordered: [{
                type: HostBinding,
                args: ['attr.bordered']
            }] } });

CrntComponentLoader$1.define();
class CrntComponentLoader {
    animation;
    timeout;
    /**
     * @region defined
     */
    defined = false;
    get _defined() {
        return this.defined ? 'defined' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntComponentLoader, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: CrntComponentLoader, isStandalone: true, selector: "crnt-component-loader", inputs: { animation: "animation", timeout: "timeout", defined: ["defined", "defined", booleanAttribute] }, host: { properties: { "attr.animation": "this.animation", "attr.timeout": "this.timeout", "attr.defined": "this._defined" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntComponentLoader, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-component-loader',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { animation: [{
                type: HostBinding,
                args: ['attr.animation']
            }, {
                type: Input
            }], timeout: [{
                type: HostBinding,
                args: ['attr.timeout']
            }, {
                type: Input
            }], defined: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _defined: [{
                type: HostBinding,
                args: ['attr.defined']
            }] } });

CrntFormGroupHelpText$1.define();
class CrntFormGroupHelpText {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroupHelpText, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: CrntFormGroupHelpText, isStandalone: true, selector: "crnt-form-group-help-text", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroupHelpText, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-group-help-text',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

CrntFormGroupLabelIndicator$1.define();
class CrntFormGroupLabelIndicator {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroupLabelIndicator, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: CrntFormGroupLabelIndicator, isStandalone: true, selector: "crnt-form-group-label-indicator", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroupLabelIndicator, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-group-label-indicator',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

CrntFormGroupLabel$1.define();
class CrntFormGroupLabel {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroupLabel, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: CrntFormGroupLabel, isStandalone: true, selector: "crnt-form-group-label", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroupLabel, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-group-label',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

CrntFormGroupValidationMessage$1.define();
class CrntFormGroupValidationMessage {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroupValidationMessage, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: CrntFormGroupValidationMessage, isStandalone: true, selector: "crnt-form-group-validation-message", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroupValidationMessage, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-group-validation-message',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

CrntFormGroup$1.define();
class CrntFormGroup {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroup, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: CrntFormGroup, isStandalone: true, selector: "crnt-form-group", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute] }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntFormGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-group',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }] } });

CrntIconButton$1.define();
class CrntIconButton extends CrntButton {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntIconButton, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: CrntIconButton, isStandalone: true, selector: "crnt-icon-button", usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntIconButton, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-icon-button',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

CrntIcon$1.define();
class CrntIcon {
    animation;
    ariaLabel;
    icon;
    size = 'base';
    /**
     * @region square
     */
    square = false;
    get _square() {
        return this.square ? 'square' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntIcon, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: CrntIcon, isStandalone: true, selector: "crnt-icon", inputs: { animation: "animation", ariaLabel: "ariaLabel", icon: "icon", size: "size", square: ["square", "square", booleanAttribute] }, host: { properties: { "attr.animation": "this.animation", "attr.aria-label": "this.ariaLabel", "attr.icon": "this.icon", "attr.size": "this.size", "attr.square": "this._square" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntIcon, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-icon',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { animation: [{
                type: HostBinding,
                args: ['attr.animation']
            }, {
                type: Input
            }], ariaLabel: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }, {
                type: Input
            }], icon: [{
                type: HostBinding,
                args: ['attr.icon']
            }, {
                type: Input
            }], size: [{
                type: HostBinding,
                args: ['attr.size']
            }, {
                type: Input
            }], square: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _square: [{
                type: HostBinding,
                args: ['attr.square']
            }] } });

CrntRadioGroup$1.define();
class CrntRadioGroup {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntRadioGroup, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: CrntRadioGroup, isStandalone: true, selector: "crnt-radio-group", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute] }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntRadioGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-radio-group',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }] } });

CrntRadio$1.define();
class CrntRadio {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    /**
     * @region bordered
     */
    bordered = false;
    get _bordered() {
        return this.bordered ? 'bordered' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntRadio, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.13", type: CrntRadio, isStandalone: true, selector: "crnt-radio", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute], bordered: ["bordered", "bordered", booleanAttribute] }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink", "attr.bordered": "this._bordered" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntRadio, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-radio',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }], bordered: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _bordered: [{
                type: HostBinding,
                args: ['attr.bordered']
            }] } });

CrntTextInput$1.define();
class CrntTextInput {
    state = 'enabled';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntTextInput, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: CrntTextInput, isStandalone: true, selector: "crnt-text-input", inputs: { state: "state" }, host: { properties: { "attr.state": "this.state" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntTextInput, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-text-input',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }] } });

CrntVisuallyHidden$1.define();
class CrntVisuallyHidden {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntVisuallyHidden, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: CrntVisuallyHidden, isStandalone: true, selector: "crnt-visually-hidden", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntVisuallyHidden, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-visually-hidden',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

const components = [CrntButton, CrntVisuallyHidden, CrntIcon, CrntComponentLoader, CrntIconButton];
class CrntTestingModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntTestingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: CrntTestingModule, imports: [CrntButton, CrntVisuallyHidden, CrntIcon, CrntComponentLoader, CrntIconButton] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntTestingModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntTestingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...components],
                }]
        }] });

class CrntRouterLink {
    el;
    router;
    href;
    routerLink;
    constructor(el, router) {
        this.el = el;
        this.router = router;
    }
    static isUrlTree(v) {
        return v instanceof UrlTree;
    }
    ngOnInit() {
        if (this.routerLink) {
            if (typeof this.routerLink === 'string') {
                this.href = this.routerLink;
            }
            else if (CrntRouterLink.isUrlTree(this.routerLink)) {
                this.href = this.router.serializeUrl(this.routerLink);
            }
            const anchorTag = this.el.nativeElement.shadowRoot?.querySelector('a');
            anchorTag?.addEventListener('click', (e) => {
                e.preventDefault();
            });
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntRouterLink, deps: [{ token: i0.ElementRef }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: CrntRouterLink, isStandalone: true, selector: "[routerLink]", inputs: { routerLink: "routerLink" }, host: { properties: { "attr.href": "this.href" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CrntRouterLink, decorators: [{
            type: Directive,
            args: [{
                    selector: '[routerLink]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1.Router }], propDecorators: { href: [{
                type: HostBinding,
                args: ['attr.href']
            }], routerLink: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { CrntButton, CrntCheckbox, CrntCheckboxGroup, CrntComponentLoader, CrntFormGroup, CrntFormGroupHelpText, CrntFormGroupLabel, CrntFormGroupLabelIndicator, CrntFormGroupValidationMessage, CrntIcon, CrntIconButton, CrntRadio, CrntRadioGroup, CrntRouterLink, CrntTestingModule, CrntTextInput, CrntVisuallyHidden };
